// src/components/common/SnackBar.jsx
import React from 'react';
import { Snackbar, Alert } from '@mui/material';

const SnackBar = ({ snackbar }) => {
  const { open, severity, message, onClose } = snackbar;

  return (
    <Snackbar open={open} autoHideDuration={6000} onClose={onClose}>
      <Alert onClose={onClose} severity={severity} sx={{ width: '100%' }}>
        {message}
      </Alert>
    </Snackbar>
  );
};

export default SnackBar;
